import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0445a96b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "user-corporate-layout"
}
const _hoisted_2 = { class: "header content-section-sp-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_corporate_header = _resolveComponent("corporate-header")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_corporate_header, {
            "user-account": _ctx.userAccount,
            "medium-id": _ctx.mediumId
          }, null, 8, ["user-account", "medium-id"])
        ]),
        _renderSlot(_ctx.$slots, "default", { userAccount: _ctx.userAccount }, undefined, true)
      ]))
    : _createCommentVNode("", true)
}